import { Contact } from "../../interfaces/contact.interface";

export const contact: Contact = {
    email: "colleen@lunapearl.co.za",
    phone: "+27 79 109 7592",
    address: "Johannesburg, South Africa"
}